import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dash",
  templateUrl: "./med-icon-dash.component.html",
})
export class MedIconDashComponent extends SvgMixinComponent {}
